import React, { Component } from 'react';
import { Button, Col, Divider, Form, Input, message, Modal, Row, Table } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import moment from 'moment';

import { BackBtn } from '@comm/BackBtn';
// import { getAccountInfo } from "../../../../store/modules/account_info";
import util from '@util';
import { queryBudgetType, queryDictExpend } from '@api/core/dict';
import {
  queryAddGroupBookList,
  queryAddGroupRecord,
  queryBudgetApportionInfo,
  queryDeleteGroupBook,
  queryGroupRecordInfo,
  queryGroupRecordList,
  queryUpdateGroupRecord,
} from '@api/finance/budget';
import ModalAdd from './ModalAdd';
import ModalApportion from './ModalApportion';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: [],
      pageNo: 1,
      total: 0,
      delUuid: '',
      content: {},
      modalAddVisible: false,
      modalEditVisible: false,
      approtionVisible: false,
      delVisible: false,
      detail: {},
      incomeType: [],
      expendType: [],
      canHandle: 2, // 判断是否可以进行添加和编辑
    };
  }

  componentWillMount() {
    this.loadBudgetIncomeType();
    this.loadBudgetExpendType();
  }

  componentDidMount() {
    this.loadData();
    // this.props.dispatch(getAccountInfo());
    this.judgeHandle();
  }

  // 判断能否进行添加和编辑操作
  judgeHandle = () => {
    const { fromPage } = this.props.location.query;
    let canHandle = 2;
    if (fromPage === 'budget') {
      canHandle = 2; // 可以添加和编辑
    } else if (fromPage === 'org') {
      canHandle = 0; // 都不可以
    } else if (fromPage === 'statis') {
      canHandle = 1; // 可已编辑但不能添加
    }
    this.setState({
      canHandle,
    });
  };

  loadData = pageNo => {
    if (this.props.location.pathname.indexOf('operational') > 0) {
      this.loadBooksIncomeList(pageNo);
    } else {
      this.loadBudgetRecord(pageNo);
    }
  };

  // 从预算管理列表查看流水
  loadBudgetRecord = pageNo => {
    let params = {};
    const { query } = this.props.location;
    if (query.type) {
      params = query;
    }
    const context = this;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 50;
    params.start = current;
    params.condition = this.state.condition || '';
    params.groupUuid = this.props.params.uuid;
    delete params.fromPage;
    this.setState({
      pageNo: current,
      isLoading: true,
    });
    queryGroupRecordList(params).then(res => {
      if (res.statusCode === 200) {
        res.data.map(item => {
          item.typeFont = this.matchType(item.target, item.type);
          return item;
        });
        context.setState({
          company: res.data,
          total: res.totalSize,
          isLoading: false,
          currentTotal: res.data.currentTotal,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 从资金运营统计进入获取流水记录列表
   */
  loadBooksIncomeList = pageNo => {
    const params = {};
    const { uuid } = this.props.params;
    if (uuid !== undefined) {
      params.bookUuid = uuid;
    }
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    this.setState({
      pageNo: current,
    });
    const { types } = this.props.income_info;
    if (types !== undefined) {
      params.type = types;
    }
    if (this.props.income_info.yearMonth) {
      params.yearMonth = this.props.income_info.yearMonth;
    } else if (this.props.income_info.date) {
      params.beginDate = moment(this.props.income_info.date[0]).format('YYYY-MM-DD');
      params.endDate = moment(this.props.income_info.date[1]).format('YYYY-MM-DD');
    }
    queryAddGroupBookList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          company: res.data,
          total: res.totalSize,
        });
      }
    });
  };

  /**
   * 按条件搜索
   */
  search = () => {
    this.loadData();
  };

  /**
   * 显示添加账户弹窗
   */
  showModalAdd = () => {
    this.setState({
      modalAddVisible: true,
    });
  };

  /**
   * 显示编辑账户弹窗
   */
  showModalEdit = uuid => {
    if (this.state.canHandle === 2) {
      this.loadDetail(uuid);
    }
  };

  hideModal = () => {
    this.setState({
      modalAddVisible: false,
      modalEditVisible: false,
      approtionVisible: false,
    });
  };

  /**
   * 新增流水记录
   */
  handAddSubmit = record => {
    record.groupUuid = this.props.params.uuid;
    queryAddGroupRecord(record).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.hideModal();
        this.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 获取流水明细
   */
  loadDetail = uuid => {
    queryGroupRecordInfo(uuid).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          detail: res.data,
          modalEditVisible: true,
        });
      }
    });
  };

  /**
   * 编辑账号
   */
  handEditSubmit = item => {
    item.uuid = this.state.detail.uuid;
    delete item.expenditure;
    delete item.income;
    delete item.target;
    queryUpdateGroupRecord(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.hideModal();
        this.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  // 删除按钮
  handleDelClick = uuid => {
    this.setState(
      {
        delUuid: uuid,
      },
      () => {
        this.handleDelVisible(true);
      },
    );
  };

  handleDelVisible = flag => {
    this.setState({
      delVisible: !!flag,
    });
  };

  // 删除流水
  handleDelOk = () => {
    const { delUuid } = this.state;
    this.props.form.validateFields(['reason'], (err, values) => {
      if (!err) {
        this.deleteRecord({
          uuid: delUuid,
          reason: values.reason,
        });
        this.handleDelVisible(false);
      }
    });
  };

  deleteRecord = params => {
    queryDeleteGroupBook(params).then(res => {
      if (res.statusCode === 200) {
        this.loadData();
        message.success(res.message);
      } else {
        message.err(res.message);
      }
    });
  };

  setCondition = e => {
    this.setState({
      condition: e.target.value,
    });
  };

  loadBudgetIncomeType = () => {
    queryBudgetType().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          incomeType: res.data,
        });
      }
    });
  };

  loadBudgetExpendType = () => {
    queryDictExpend().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          expendType: res.data,
        });
      }
    });
  };

  dealApportion = apportionUuid => {
    this.loadApportionDetail(apportionUuid);
  };

  loadApportionDetail = uuid => {
    queryBudgetApportionInfo(uuid).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          content: res.data,
        });
        this.setState({
          approtionVisible: true,
        });
      } else if (res.statusCode === 500) {
        message.info(res.message);
      }
    });
  };

  matchType = (target, value) => {
    let type = '';
    if (+target === 1) {
      this.state.incomeType.map(item => {
        if (item.value === value) {
          type = item.key;
          return type;
        }
        return type;
      });
    }
    if (+target === 0) {
      this.state.expendType.map(item => {
        if (item.value === value) {
          type = item.key;
        }
        return type;
      });
    }
    return type;
  };

  columns = () => {
    const { isAdmin } = this.props.account_info;
    const columns = [
      {
        title: '流水编号',
        dataIndex: 'no',
        key: 'no',
        // render: (text, record) => {
        //   return (
        //     <a onClick={() => this.showModalEdit( record.uuid)}>{text}</a>
        //   );
        // }
      },
      {
        title: '费用',
        dataIndex: 'income',
        key: 'income',
        render: (text, record) => {
          return record.expenditure ? (
            <span style={{ color: 'red' }}>
              {util.numberFormat(record.expenditure, 2, '.', ',')}
            </span>
          ) : (
            <span style={{ color: 'green' }}>{util.numberFormat(record.income, 2, '.', ',')}</span>
          );
        },
      },
      {
        title: '预算组',
        dataIndex: 'groupName',
        key: 'groupName',
      },
      {
        title: '摘要',
        dataIndex: 'remark',
        key: 'remark',
        width: '20%',
      },
      {
        title: '预算科目',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => {
          return <span>{record.typeFont}</span>;
        },
      },
      {
        title: '发生时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record) => {
          const style = {};
          if (record.noticeFlag === 1) {
            style.color = 'red';
          }
          return (
            <span style={style}>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>
          );
        },
      },

      {
        title: '操作',
        key: 'done',
        render: (text, record) => {
          if (record.type !== '210' && record.type !== '21w') {
            return (
              <span>
                {record.apportion ? (
                  <span>
                    {record.apportion.itemType === 0 ? (
                      <Link to={`/finance/e_manage/open/${record.apportion.itemUuid}`}>
                        报销明细
                      </Link>
                    ) : null}
                    {record.apportion.itemType === 1 ? (
                      <Link to={`/finance/p_manage/open/${record.apportion.itemUuid}`}>
                        付款明细
                      </Link>
                    ) : null}
                    {record.apportion.itemType === 2 ? (
                      <Link to={`/finance/l_manage/open/${record.apportion.itemUuid}`}>
                        借款明细
                      </Link>
                    ) : null}
                    {record.apportion.itemType === 0 ||
                    record.apportion.itemType === 1 ||
                    record.apportion.itemType === 2 ? (
                      <Divider type="verticle" />
                    ) : null}
                  </span>
                ) : null}

                <a onClick={() => this.dealApportion(record.apportionUuid)}>分摊明细</a>
                {isAdmin ? (
                  <span>
                    <Divider type="vertical" />
                    <a
                      className="ant-dropdown-link"
                      onClick={() => this.handleDelClick(record.uuid)}
                    >
                      删除
                    </a>
                  </span>
                ) : null}
              </span>
            );
          }
        },
      },
    ];
    return columns;
  };

  render() {
    const {
      total,
      company,
      isLoading,
      content,
      incomeType,
      expendType,
      delVisible,
      // canHandle,
      // source,
    } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 50,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };

    const {
      form: { getFieldDecorator },
    } = this.props;

    return (
      <div>
        <div className="fixed-header">
          <Row type="flex" justify="space-between">
            <Col>
              <BackBtn />
              {/* {canHandle === 2 && source !== "operational" ? (
                <Button
                  icon="plus"
                  style={{ marginBottom: 15 }}
                  onClick={this.showModalAdd}
                >
                  添加
                </Button>
              ) : (
                ""
              )} */}
            </Col>
            <Col style={{ textAlign: 'right' }}>
              <Input
                placeholder="请输入关键字"
                style={{ width: '300px' }}
                value={this.state.condition}
                onChange={this.setCondition}
              />
              <Button type="primary" style={{ marginLeft: '10px' }} onClick={this.search}>
                搜索
              </Button>
            </Col>
          </Row>
        </div>
        <Table
          rowKey={record => record.uuid}
          rowSelection={{}}
          columns={this.columns()}
          dataSource={company}
          pagination={pagination}
          loading={isLoading}
          style={{ paddingTop: '46px' }}
          size="small"
        />
        {this.state.modalAddVisible ? (
          <ModalAdd
            handSubmit={this.handAddSubmit}
            detail={{}}
            incomeType={incomeType}
            expendType={expendType}
            cancel={this.hideModal}
            disabled={false}
          />
        ) : (
          ''
        )}
        {this.state.modalEditVisible ? (
          <ModalAdd
            handSubmit={this.handEditSubmit}
            detail={this.state.detail}
            uuid={this.uuid}
            incomeType={incomeType}
            expendType={expendType}
            cancel={this.hideModal}
            disabled
          />
        ) : (
          ''
        )}
        {this.state.approtionVisible ? (
          <ModalApportion cancel={this.hideModal} content={content} expendType={expendType} />
        ) : (
          ''
        )}
        <Modal
          title="删除原因"
          visible={delVisible}
          onOk={this.handleDelOk}
          onCancel={() => this.handleDelVisible(false)}
        >
          <Form>
            <FormItem label="删除原因">
              {getFieldDecorator('reason', {
                rules: [{ required: true, message: '请输入删除原因' }],
              })(<Input placeholder="请输入删除原因" />)}
            </FormItem>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default connect(state => ({
  user: state.user,
  income_info: state.income_info,
  account_info: state.account_info,
}))(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/finance/budget/check/Index.js